// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-2b53520a","scoped":false,"hasInlineConfig":false}!./src/components/nudge-console/nudge-console-pager.css
// module id = Pr1b
// module chunks = 1